import { QueryDispatcher } from "@/modules/shared/domain/QueryDispatcher";

export class ActivitiesQuery {
  constructor(
    private readonly dispatcher: QueryDispatcher,
    private readonly frontend,
  ) { }

  async run(company_id:String|Number): Promise<any> {
    let args = { 
        company_id: company_id,
    }
    let res = undefined;    
    res = await this.dispatcher.dispatch('bank.activities.get', args)    
    if (res.status === '200') {
      this.frontend.activities = res.data      
    } else {
      return res.data
    }    
  }
}